import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  BlindingLevel,
  Category,
  CsvDelimiter,
  DataExportRequest,
  ExportDataFormat,
  FileFormat,
  WideFormatHeaderType,
} from '@core/services/api-client.generated';
import { INormalizedPayload } from '@core/state/entities/entity';
import { DataExportJobsKey } from '@core/state/entities/entity-name-map';
import {
  IErrorStateWithCorrelation,
  IRequestCorrelationState,
} from '@core/actions/project-detail.actions';
import { DataExportFileInfo, ExportType } from '@core/state/ui/data-export/data-export.effects';

export const dataExportServiceActions = createActionGroup({
  source: 'Data Export Service',
  events: {
    'Bibliographic Data Received': emptyProps(),
    'Screening Data Received': emptyProps(),
    'Annotation Data Received': emptyProps(),
    'Quantitative Data Received': emptyProps(),
    'Bibliographic Data Error': props<{ error: string }>(),
    'Screening Data Error': props<{ error: string }>(),
    'Annotation Data Error': props<{ error: string }>(),
    'Quantitative Data Error': props<{ error: string }>(),
    'Data Export Job Created': props<
      INormalizedPayload<DataExportJobsKey> & {
        jobId: string;
        fileInfo: DataExportFileInfo;
      } & IRequestCorrelationState
    >(),
    'Error Creating Data Export Job': props<IErrorStateWithCorrelation>(),
    'Data Export Received Successfully': props<
      {
        jobId: string;
      } & IRequestCorrelationState
    >(),
    'Error Receiving Data Export': props<
      {
        jobId: string;
      } & IErrorStateWithCorrelation
    >(),
  },
});
export const dataExportJobSubscriptionActions = createActionGroup({
  source: 'Data Export Job Subscription',
  events: {
    'Data Export Job Update': props<
      INormalizedPayload<DataExportJobsKey> & { jobId: string }
    >(),
    'Data Export Job Deleted': props<{
      jobId: string;
    }>(),
  },
});
export const dataExportComponentActions = createActionGroup({
  source: 'Data Export Component',
  events: {
    'Create Data Export Job': props<
      DataExportRequest & IRequestCorrelationState & {
      exportType: ExportType;
      delimiter?: CsvDelimiter | null;
    }
    >(),
    'Get Bibliographic Data': props<{
      projectId: string;
      fileFormat: FileFormat;
      onlyIncluded: boolean;
      importCompatible: boolean;
    }>(),
    'Get Screening Data': props<{
      projectId: string;
      fileFormat: FileFormat;
      dataFormat:
        | ExportDataFormat.LongScreening
        | ExportDataFormat.WideScreening;
      blindingLevel: BlindingLevel;
      bibliographic: boolean;
    }>(),
    'Get Annotation Data': props<{
      projectId: string;
      fileFormat: FileFormat;
      dataFormat: ExportDataFormat.Long | ExportDataFormat.Wide;
      category: Category;
      stageIds: string[];
      blindingLevel: BlindingLevel;
      splitBySession: boolean;
      bibliographic: boolean;
      wideFormatHeaderType: WideFormatHeaderType;
      onlyCompleted: boolean;
    }>(),
    'Get Quantitative Data': props<{
      projectId: string;
      fileFormat: FileFormat;
      outcomeLookupQuestions: string[];
      stageIds: string[];
      blindingLevel: BlindingLevel;
      splitBySession: boolean;
      bibliographic: boolean;
      includeComments: boolean;
    }>(),
  },
});
